import { render, staticRenderFns } from "./DashboardPaciente.vue?vue&type=template&id=6c3bc28f&scoped=true&"
import script from "./DashboardPaciente.vue?vue&type=script&lang=js&"
export * from "./DashboardPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3bc28f",
  null
  
)

export default component.exports